// extracted by mini-css-extract-plugin
module.exports = {"flag":"VoteProgress_flag__RaFR2","label":"VoteProgress_label__4KKz1","line":"VoteProgress_line__baE45","track":"VoteProgress_track__dG0cJ","item":"VoteProgress_item__1XBiE"};